module.exports = __webpack_public_path__ + "img/xhs.34a70e1d.jpg";